import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { collection, query, where, limit, getDocs } from 'firebase/firestore';
import { auth, db } from '../firebase';

export const useAdminAuth = () => {
  const [isAuthReady, setIsAuthReady] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user && user.email) {
        try {
          const q = query(
            collection(db, 'adminUsers'),
            where('email', '==', user.email.toLowerCase()),
            where('status', '==', 'active'),
            limit(1)
          );
          const snap = await getDocs(q);
          setIsAuthReady(!snap.empty && snap.docs[0].data().approved === true);
        } catch {
          setIsAuthReady(false);
        }
      } else {
        setIsAuthReady(false);
      }
      setIsLoading(false);
    });

    return unsubscribe;
  }, []);

  return { isAuthReady, isLoading, error: null };
};
